<template>
    <div class="pt-15 animated fadeIn masterGLaccount staticPageInner equipmentList bgV2">
        <b-row no-gutters>
            <b-col md="12" class="heig-frame-child">
                <gofix-tab
                    class="mt-3 contractPropertyTab"
                    activeKey="contact-site"
                    variableWidth
                    :data="tabs">
                    <template slot="gofixTab:contact-site">
                        <gofix-card class="mb-0 heig-frame-child" fullContent>
                            <gofix-default-table :settings="tableConfig"
                                :table-items="tableItems"
                                @load-items="getTableData"
                                @new-item="openCreateModal"
                                @delete-items="deleteItems"
                                @row-click="openCreateModal"
                                ref="gofixTable">
                            </gofix-default-table>
                        </gofix-card>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
        <b-modal :no-close-on-backdrop="true"
            @hidden="closeCreateModal"
            id="modal-Create"
            :title="modals.create.title" hide-footer :centered="true"
            modal-class="mw-contact-site"
            v-model="modals.create.open">
            <b-form class="pb-20">
                <b-row>
                    <b-col md="6">
                        <gofix-form-dropdown
                        label="Client Contract"
                        vLabel="contract_name"
                        :required="true"
                        :reduce="contract => contract.id"
                        v-model="modals.create.data.client_contract_id"
                        :options="modals.create.contract" />
                    </b-col>
                     <b-col md="6">
                        <gofix-form-properties
                            label="Property"
                            :contract-id="modals.create.data.client_contract_id"
                            v-model="modals.create.data.property"
                            valueFormat="object"
                            required />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="6">
                        <gofix-form-input label="Site name" v-model="modals.create.data.site_name" />
                    </b-col>
                    <b-col md="6">
                        <gofix-form-input label="Contact Name" v-model="modals.create.data.contact_name" />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="6">
                        <gofix-form-input type="email" autocomplete="off" label="Email" v-model="modals.create.data.email" />
                    </b-col>
                    <b-col md="6">
                        <gofix-form-input-number
                                label="Telephone No"
                                v-model="modals.create.data.telephone_no"
                                :integer-limit="15"
                                :include-thousands-separator="false"
                                :allowDecimal="false">
                        </gofix-form-input-number>
                    </b-col>
                </b-row>
                <!--<b-row>
                    <b-col md="12" class="mb-4">
                        <gofix-text-field label="Address">
                            <template slot="gofixTextField:after_label">
                                <gofix-button class="editRight float-right" label="Edit" @click='showAddress = !showAddress' noBorder fontNormal small></gofix-button>
                            </template>
                            qqqqqqqqq
                        </gofix-text-field>
                    </b-col>
                </b-row>-->
                <b-row>
                    <b-col md="6">
                        <gofix-form-input-number
                                label="Fax No"
                                v-model="modals.create.data.fax_no"
                                :integer-limit="15"
                                :include-thousands-separator="false"
                                :allowDecimal="false">
                        </gofix-form-input-number>
                    </b-col>
                    <b-col md="6">
                        <gofix-form-input label="Street Number" v-model="modals.create.data.street_no"></gofix-form-input>
                    </b-col>
                    <b-col md="6">
                        <gofix-form-input label="Street Name" v-model="modals.create.data.street_name"></gofix-form-input>
                    </b-col>
                    <b-col md="6">
                        <gofix-form-input label="Unit no" v-model="modals.create.data.unit_no"></gofix-form-input>
                    </b-col>
                    <b-col md="6">
                        <gofix-form-input label="Building Name" v-model="modals.create.data.building_name"></gofix-form-input>
                    </b-col>
                    <b-col md="6">
                        <gofix-form-input label="Country" v-model="modals.create.data.country" disabled></gofix-form-input>
                    </b-col>
                    <b-col md="6">
                        <gofix-form-input label="Postal code" v-model="modals.create.data.postal_code"></gofix-form-input>
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" @click="saveData" :loading="modals.create.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>
<script>
    import tabData from '@/data/_tabs';
    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js';
    import { generalAddressFormat } from "./../../_commonVar.js";
    export default {
        name: 'contact-site',
        data() {
            let filter = JSON.parse(JSON.stringify(filters['contact_site']));
            return {
                tabs: tabData.tenants,
                tableConfig:{
                    name: 'contact-site-listing',
                    controls:{
                        tableImport: false,
                        tableExport: false,
                        create: this.$checkRole(this.$accessModule.tenant_site, 'create'),
                        delete: this.$checkRole(this.$accessModule.tenant_site, 'delete'),
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: false,
                    sortColumn: "contract_name",
                    sortDirection: "asc",
                },
                showAddress:false,
                tableItems: [],
                modals:{
                    create:{
                        open:false,
                        loading: false,
                        title: "Add Contact Site",
                        data:{
                            id: null,
                            property: null,
                            property_id: null,
                            client_contract_id: null,
                            site_name: null,
                            contact_name: null,
                            email:null,
                            display_address:null,
                            telephone_no:null,
                            fax_no:null,
                            street_no:null,
                            street_name:null,
                            unit_no:null,
                            building_name:null,
                            country:'Singapore',
                            postal_code:null
                        },
                        contract:[],
                        properties: [],
                    },
                    activeAddress:{
                        street_no:null,
                        street_name:null,
                        unit_no:null,
                        building_name:null,
                        country:'Singapore',
                        postal_code:null
                    }
                },
                localHref : window.location.origin
            }
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID'
            })
        },
        watch : {
            "modals.create.data.client_contract_id": function(val,old){
                if(old){
                    this.modals.create.data.property = null;
                    this.modals.create.data.property_id = null;
                }
            },
        },
        created() {
            this.loadContract();
        },
        methods: {
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("ContactSiteController/getItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load the items", "danger");
                        reject();
                    })
            },
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                this.$store.dispatch("ContactSiteController/deleteItems", ids)
                    .then(response => {
                        resolve(this.$notificationV2('deleting', 'contact_site'));
                    })
                    .catch(err =>{
                        reject(err);
                    });
            },
            loadContract(){
                this.$store.dispatch('ContractController/getListClientContractsSearch', [1, null, -1])
                    .then(response => {
                        this.modals.create.contract = response.data;
                    })
                    .catch(error => {
                        this.modals.create.contract = [];
                    });
            },
            openCreateModal(item){
                if(!item){
                    this.modals.create.title = "Add Contact Site";
                    this.modals.create.data = {
                        id: null,
                        property: null,
                        property_id: null,
                        client_contract_id: null,
                        site_name: null,
                        contact_name: null,
                        address_id:null,
                        email:null,
                        telephone_no:null,
                        fax_no:null,
                        street_no:null,
                        street_name:null,
                        unit_no:null,
                        building_name:null,
                        country:'Singapore',
                        postal_code:null,
                        display_address:null
                    }
                }else{

                    if ( this.$checkRole(this.$accessModule.tenant_site, 'update') == false ) {
                        return;
                    }

                    this.modals.create.title = "Edit Contact Site";
                    this.modals.create.data = {
                        id: item.id,
                        property: {
                            name: item.property_name,
                            id: item.property_id,
                        },
                        property_id: item.property_id,
                        client_contract_id: item.client_contract_id,
                        site_name: item.site_name,
                        contact_name: item.contact_name,
                        email: item.email,
                        telephone_no:item.telephone_no,
                        fax_no:item.fax_no,
                        street_no:item.street_no,
                        street_name:item.street_name,
                        unit_no:item.unit_no,
                        building_name:item.building_name,
                        country:'Singapore',
                        postal_code:item.postal_code,
                        display_address:item.display_address
                    };
                }
                this.modals.create.open = true;
            },
            closeCreateModal(){
                this.modals.create.title = "Add Contact Site";
                this.modals.create.data = {
                    id: null,
                    property: null,
                    property_id: null,
                    client_contract_id: null,
                    site_name: null,
                    contact_name: null,
                    address_id:null,
                    email:null,
                    telephone_no:null,
                    fax_no:null,
                    street_no:null,
                    street_name:null,
                    unit_no:null,
                    building_name:null,
                    country:'Singapore',
                    postal_code:null,
                    display_address:null
                }
            },
            saveData() {
                if(!this.modals.create.data.site_name) return this.$alertNotification("Please enter the site name", "danger");
                if(!this.modals.create.data.contact_name) return this.$alertNotification("Please enter the contact name", "danger");
                if(!this.modals.create.data.client_contract_id) return this.$alertNotification("Please select a contract", "danger");
                if(!this.modals.create.data.property) return this.$alertNotification("Please select a property", "danger");

                if(this.modals.create.loading) return;
                this.modals.create.loading = true;
                this.modals.create.data.property_id = this.modals.create.data.property ? this.modals.create.data.property.id : null;
                let address = {
                    street_no: this.modals.create.data.street_no,
                    street_name:this.modals.create.data.street_name,
                    unit_no:this.modals.create.data.unit_no,
                    building_name:this.modals.create.data.building_name,
                    country:'Singapore',
                    postal_code:this.modals.create.data.postal_code,
                };
                this.hanldeAddress(address);
                let action = 'createItem';
                let keyMessage= 'adding'
                if(this.modals.create.data.id){
                    action = 'updateItem';
                    keyMessage = 'editing'
                }
                this.$store.dispatch(`ContactSiteController/${action}`, this.modals.create.data)
                    .then(result => {
                        this.modals.create.loading = false;
                        this.modals.create.open = false;
                        this.$alertNotification(this.$notificationV2(keyMessage, 'contact_site'));
                        this.$store.dispatch("AuthController/getRoles");
                        this.$refs.gofixTable.reloadTableKeepFilter();
                    })
                    .catch(error => {
                        this.modals.create.loading = false;
                        if(error.response) return this.$alertNotification(error.response.data.error.message.message, "danger");
                    })
            },
            hanldeAddress(address){
                this.modals.create.data.display_address = generalAddressFormat(address)
            }
        }
    }
</script>
<style>
    .mw-contact-site .modal-dialog{
        max-width:650px !important;
    }
</style>